import React, { Component } from 'react';
import {
	UncontrolledAlert
} from 'reactstrap';
import axios from 'axios';

export default class BroadcastAlert extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fetched: false,
			active: false,
			color: 'info',
			content: null
		}
	}
	get() {
		if (process.env.REACT_APP_FRONT_END === "true") {
			this.setState({
				fetched: true
			});
			return;
		}
		axios.get('/api/broadcast-alert')
		.then((res) => {
			this.setState({
				fetched: true,
				active: res.data.active,
				color: res.data.color,
				content: res.data.content
			});
		})
		.catch((err) => {
			console.log(err);
			this.setState({
				fetched: true,
				active: false
			});
		});
	}
	componentDidMount() {
		this.get();
	}

	render() {
		if (!this.state.fetched || !this.state.active) {
			return (null);
		}
		return (
			<UncontrolledAlert color={this.state.color} style={{position: "fixed", height: "50px", bottom: "-16px", width: "100%"}}>
				{this.state.content}
			</UncontrolledAlert>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/BroadcastAlert.js